document.addEventListener('liquid-ajax-cart:request-end', event => {
    const { requestState } = event.detail;

    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        // Add the CSS class to the "body" tag
        document.documentElement.classList.add('js-ajax-cart-open');
    }
});

//upsells
const swiper = new Swiper('.swiper-upsells', {
    loop: true,
    navigation: {
        nextEl: '.u-next',
        prevEl: '.u-prev',
    }
});

// free gift logic

const freeGift = _ => {
    const cart = window.liquidAjaxCart.cart
    const gift = 46364795633896
    if (cart.item_count === 0) {
        return
    }
    const hasGift = cart.items.some(item => item.variant_id === gift)
    console.log("first", hasGift)

    const hasProduct = cart.items.some(item => item.product_id === 6261152383125)
    console.log("sadsa", hasProduct)
    if (hasProduct && !hasGift) {
        return {
            requests: [
                {
                    type: "add",
                    body: {
                        items: [{
                            id: gift,
                            quantity: 1,
                        }]
                    }
                }
            ]
        }
    } else if (!hasProduct && hasGift) {
        const product = cart.items.find(item => item.variant_id === gift)
        console.log(product)
        return {
            requests: [
                {
                    type: "change", // remove the first item from the cart
                    body: {
                        id: product.key,
                        quantity: 0
                    }
                }
            ]
        }
    } else if (hasGift) {
        return
    }
}
